import Vue from 'vue'
import VueAppInsights from 'vue-application-insights'
import { initRouter } from '@/_standalone/plugins/vue-router'

export default function(ctx, inject, envName, routes) {
  const instrumentationKey = '7fb33eb0-5f9b-4813-a8e3-667c2f231630'
  const _envName = process?.env?.envName || envName
  const enable = _envName === 'staging' || _envName === 'master'
  const _router = ctx?.router || initRouter(routes)

  if (enable) {
    Vue.use(VueAppInsights, {
      id: instrumentationKey,
      router: _router,
      baseName: 'pwa',
      appInsightsConfig: {
        instrumentationKey,
        enableAutoRouteTracking: true,
        disableTelemetry: false,
        disableExceptionTracking: false
      }
    })
  }
}
